import { GlobalAppState } from '@state/store';

export const getTransfers = (state: GlobalAppState) => state.extras.data.transfers;
export const getLuggage = (state: GlobalAppState) => state.extras.data.luggageExtras;
export const getOptionalSupplements = (state: GlobalAppState) => state.extras.data.optionalSupplements;
export const getIsExtrasLoading = (state: GlobalAppState) => state.extras.loading;
